module.exports = __webpack_public_path__ + "img/61550bbcf6abe311574730b9c17e29cb.0c3d473e.png";